import HelpContainer from 'components/help/HelpContainer';
import HelpInstruction from 'components/help/HelpInstruction';
import HelpSection from 'components/help/HelpSection';
import HelpTable from 'components/help/HelpTable';
import DownloadPdf from 'components/icons/DownloadPdf';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SettingsIcon from '@mui/icons-material/Settings';
import { AddIcon, Alert, AlertLetter, LogIcon } from 'components/UI/dialogs/HelpDialogStyled';

const HelpDialog = () => {
    const overviewList = ['Add new equipment to the authorized list', 'Update existing equipment records', 'Assign or modify alert types'];

    const controls = [
        {
            action: 'Add new',
            icon: <AddIcon />,
            description: 'Add a new equipment item to the authorized list manually.',
        },
        {
            action: 'Modify record',
            icon: <MoreVertIcon />,
            description: "Edit or remove the equipment's information.",
        },
        {
            action: 'Download options',
            icon: <DownloadPdf />,
            description: 'Export the current list of authorized equipment in the preferred file format.',
        },
        {
            action: 'Configure Location',
            icon: <SettingsIcon />,
            description: "When enabled, unique inbound and outbound equipment will be automatically added to this location's list.",
        },
    ];

    const alerts = [
        {
            action: 'Status',
            icon: null,
            description:
                'Reflects the current operational state of the equipment (e.g., Good To Go, Grounded, In Shop, Annual Inspect, Breakdown, etc.). Used primarily to evaluate readiness and usage eligibility.',
            reversed: true,
        },
        {
            action: 'Default',
            icon: (
                <Alert color="#747692">
                    <AlertLetter color="#ffffff">D</AlertLetter>
                </Alert>
            ),
            description: 'No special conditions. Normal facility entry and exit allowed.',
            reversed: true,
        },
        {
            action: 'Banned',
            icon: (
                <Alert color="#FF0000">
                    <AlertLetter color="#ffffff">B</AlertLetter>
                </Alert>
            ),
            description: 'Access denied. The equipment is prohibited from entering the facility.',
            reversed: true,
        },
        {
            action: 'Privileged equipment',
            icon: (
                <Alert color="#3FC6A9">
                    <AlertLetter color="#ffffff">P</AlertLetter>
                </Alert>
            ),
            description: 'Equipment has special access, allowing for personal or scheduled entry/exit.',
            reversed: true,
        },
        {
            action: 'Specialized Pickups',
            icon: (
                <Alert color="#CDDC39">
                    <AlertLetter color="#ffffff">S</AlertLetter>
                </Alert>
            ),
            description: 'Authorized for specific trailer pickups or delivery tasks within the facility.',
            reversed: true,
        },
        {
            action: 'Information',
            icon: (
                <Alert color="#AB47BC">
                    <AlertLetter color="#ffffff">I</AlertLetter>
                </Alert>
            ),
            description: 'Extra protocols or information apply to this vehicle or assignment.',
            reversed: true,
        },
        {
            action: 'Alert Notes',
            icon: (
                <Alert color="#fff">
                    <AlertLetter color="#ffffff">A</AlertLetter>
                </Alert>
            ),
            description: 'Custom instruction.',
            reversed: true,
        },
    ];

    const instructions = [
        {
            title: 'Adding New Equipment',
            steps: [
                <>
                    <span>Click on the</span>
                    <span>
                        <AddIcon />
                    </span>
                    <span>Add new button.</span>
                </>,
                'Fill out the equipment record form with the required information (e.g., Equipment Category, Equipment Number, Company, etc.).',
                'Click “Save” to add the equipment to the authorized list.',
            ],
        },
        {
            title: 'Filtering Alert Type',
            steps: [
                'Toggle the switches next to each alert type to filter the list of equipment.',
                'The list will automatically update based on the alert types you have toggled on or off.',
                'You can further refine the list by using the search bar at the top of the sidebar to filter by Equipment Category, Equipment number, or Organization.',
            ],
        },
        {
            title: 'View Changes Log',
            steps: [
                <>
                    <span>Click on the</span>
                    <span>
                        <LogIcon />
                    </span>
                    <span>icon.</span>
                </>,
                'The Changes Log section will appear at the bottom of the page, where you can view recent changes made to the authorized list.',
            ],
        },
    ];

    return (
        <HelpContainer
            width="52rem"
            overview={
                <span>
                    Control which equipment is authorized within a facility and manage the type of alert associated with each equipment record. <br />
                    <br />
                    You can:
                </span>
            }
            overviewList={overviewList}
        >
            <HelpSection title="CONTROLS" hasTopDivider={true}>
                <HelpTable rows={controls} />
            </HelpSection>
            <HelpSection
                title="ALERTS"
                description="Set up specialized alerts that will be used by gate agents to control access rights for each equipment:"
                hasTopDivider={true}
            >
                <HelpTable title="Alerts" rows={alerts} />
            </HelpSection>
            <HelpSection title="INSTRUCTIONS" hasTopDivider={true}>
                <HelpInstruction instructions={instructions} height={'13rem'} />
            </HelpSection>
        </HelpContainer>
    );
};

export default HelpDialog;
